import { render, staticRenderFns } from "./Tweet.vue?vue&type=template&id=73139972&"
import script from "./Tweet.vue?vue&type=script&lang=js&"
export * from "./Tweet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports